const stateCheckinProgrammed = {
    nameState: 'State global programmed checkin',
    programmed: null,
    client: {},
}

export default stateCheckinProgrammed;